// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"287":"d488982a","318":"61e45f91","792":"3b91c263","794":"34ba2fed","861":"d488982a"}[chunkId] + ".css";
};